import { SET_VOLUME, PLAY, STOP } from "./actionTypes";

export const setVolume = (payload) => {
  return {
    payload,
    type: SET_VOLUME,
  };
};

export const play = (payload) => {
  return {
    payload,
    type: PLAY,
  };
};

export const stop = (payload) => {
  return {
    payload,
    type: STOP,
  };
};
